import m from 'moment-timezone';



function momentCalendar(value, customFormats, timeZone) {
  /**
   * https://momentjs.com/docs/#/customization/calendar/
   */
  const defaultFormats = {
    sameDay: '[Today @] h:mm A',
    nextDay: '[Tomorrow @] h:mm A',
    lastDay: '[Yesterday @] h:mm A',
    nextWeek: 'dddd [@] h:mm A',
    lastWeek: 'M/D/YY [@] h:mm A',
    sameElse: 'M/D/YY [@] h:mm A'
  };

  const formats = customFormats || defaultFormats;

  if (value && timeZone) {
    return m(value).tz(timeZone).calendar(null, formats);
  }

  if (value) {
    return m(value).calendar(null, formats);
  }

  return '';
}



export default momentCalendar;
